import { Box, FormHelperText, InputLabel, Typography } from "@mui/material";
import { useRCAMainStyles } from "../../RCA.styles";
import { useTranslation } from "react-i18next";
import { IRCAPriorityDropdown } from "./RCAPriorityDropdownInterfaces";
import LowPriorityIcon from "pages/Corporate/RCA/images/low_priority_icon.svg";
import MediumPriorityIcon from "pages/Corporate/RCA/images/medium_priority_icon.svg";
import HighPriorityIcon from "pages/Corporate/RCA/images/high_priority_icon.svg";
import { DefaultTranslationFieldsInTable, RCA_PRIORITIES, RCA_PRIORITIES_KEY_TRANSLATIONS } from "constants/constants";
import { PriorityEntity } from "entities/RCA/PriorityEntity/PriorityEntity";
import NewMainSelect from "components/NewMainSelect/NewMainSelect.view";
import { translateDefaultEntity } from "utilities/localesUtilities";

const RCAPriorityDropdown = ({ errors, value, handleChange, touched, disabled }: IRCAPriorityDropdown) => {
    const mainClasses = useRCAMainStyles();
    const { t, i18n } = useTranslation();
    const { priorities, loading } = PriorityEntity.GetPriorities();

    const rcaPriorityIcons = {
        [RCA_PRIORITIES.LOW]: LowPriorityIcon,
        [RCA_PRIORITIES.MEDIUM]: MediumPriorityIcon,
        [RCA_PRIORITIES.HIGH]: HighPriorityIcon,
    };

    const rcaStatusOptions = priorities.map((priority) => ({
        id: priority.priority_id,
        name: translateDefaultEntity(i18n.language, priority, "name", DefaultTranslationFieldsInTable.PRIORITY),
        icon: <img src={rcaPriorityIcons[priority.priority_id]} alt="Priority" />,
    }));

    return (
        <Box className={mainClasses.contentFormBox}>
            <InputLabel id="outlined-priorityId-label">
                <Typography variant="subtitle2" className={mainClasses.contentFormLabel}>
                    {t("rca.priority_select.title")}
                </Typography>
            </InputLabel>

            <>
                <NewMainSelect
                    disabled={loading || priorities.length === 0 || disabled}
                    options={rcaStatusOptions || []}
                    name="priorityId"
                    value={value}
                    onChange={(value) => {
                        handleChange(value);
                    }}
                    placeholder={t("rca.priority_select.please_select")}
                    renderValue={(value) => {
                        return (
                            <div className={mainClasses.contentSelectWithIcon}>
                                <img src={rcaPriorityIcons[value as keyof typeof rcaPriorityIcons]} alt="Priority" />
                                <Typography variant="body2">
                                    {t(
                                        `rca.priority_select.${
                                            RCA_PRIORITIES_KEY_TRANSLATIONS[
                                                value as keyof typeof RCA_PRIORITIES_KEY_TRANSLATIONS
                                            ]
                                        }`,
                                    )}
                                </Typography>
                            </div>
                        );
                    }}
                />
                {!!errors.priorityId && !!touched.priorityId && <FormHelperText>{t(errors.priorityId)}</FormHelperText>}
            </>
        </Box>
    );
};

export default RCAPriorityDropdown;
